import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../context/app-context';
import { questionerResponse } from '../context/staticData';
import { getAge } from '../helper';
import API from '../helper/API';
import { callUserAPIWebView } from '../helper/mobile';

export const useRiskAssessment = () => {

    const [state, dispatch] = useContext(AppContext);
    let navigate = useNavigate();

    const assessmentQuestion = (que) => {
        let objData = [];
        questionerResponse.forEach(obj => {
            if(obj.questionerLabel === 'family_diabieties_history'){
                obj.responseText = que.diabetes;
                obj.scoreOfResponse = que.diabetes === 'yes' ? 1 : 0;
                objData.push(obj);
            }
            else if(obj.questionerLabel === 'high_blood_pressure'){
                obj.responseText = que.bloodPressure;
                obj.scoreOfResponse = que.bloodPressure === 'yes' ? 1 : 0;
                objData.push(obj);
            }
            else if(obj.questionerLabel === 'physically_active'){
                obj.responseText = que.physicallyActive;
                obj.scoreOfResponse = que.physicallyActive === 'yes' ? 0 : 1;
                objData.push(obj);
            }
            else if(obj.questionerLabel === 'gestational_diabetes' && state.user.gender.toLowerCase() === 'female'){
                obj.responseText = que.gestationalDiabetes;
                obj.scoreOfResponse = que.gestationalDiabetes === 'yes' ? 1 : 0;
                objData.push(obj);
            }
        });
        return objData
    };

    const saveRiskAssessment = () => {

        let scoreCount = 0;
        const user = state.user;
        const userAge = getAge(user.dob);
        const risk = state.riskAssessment;
        const tempBmi = JSON.parse(localStorage.getItem('tempBmi'));
        let questionArray = assessmentQuestion(risk);

        scoreCount += risk.diabetes === 'yes' ? 1 : 0;
        scoreCount += risk.bloodPressure === 'yes' ? 1 : 0;
        scoreCount += risk.physicallyActive === 'no' ? 1 : 0;

        if(userAge >= 60)
            scoreCount += 3
        else if(userAge < 60 && userAge >= 50)
            scoreCount += 2
        else if(userAge < 50 && userAge >= 40)
            scoreCount += 1

        if(user.gender.toLowerCase() === 'male')
            scoreCount += 1
        else
            scoreCount += risk.gestationalDiabetes === 'yes' ? 1 : 0;

        if(tempBmi.bmi >= 40)
            scoreCount += 3
        else if(tempBmi.bmi < 40 && tempBmi.bmi >= 30)
            scoreCount += 2
        else if(tempBmi.bmi < 30 && tempBmi.bmi >= 25)
            scoreCount += 1

        
        const request = {
            "userId": user.id,
            "groupId": user.id,
            "assessmentType": "diabetes",
            "userInfo": tempBmi,
            "questionerResponse": questionArray,
            "assessmentScore": scoreCount,
            "appVersion":user.appVersion,
	        "osType":user.osType
        }
        
        API.post('/user/risk-assessment', request).then(response => {
            if(response.status === 201) {
                dispatch({
                    type: "RISK_ASSESSMENT",
                    payload: {preRiskAssessment : response.data}
                });
                callUserAPIWebView();
                navigate('/riskAssessment/yourResult');
            }
        }).catch(error => {
          console.log("Error", error);
        })
    }

    return {
        saveRiskAssessment
    }
}